import type { ParamsValidator } from "@whilecat/core/tasks/validators/params-validator.js";
import { sanityCheck } from "@whilecat/core/utils/validation.js";
import type { TemplateResult } from "lit";

export type QuizTaskParams = {
    options: Array<string>;
    almostTrueOptions?: Map<string, string> | undefined;
    correctAnswer: string;
    question: string;
    code?: string;
    content?: TemplateResult | undefined;
};

export class QuizParamsValidator implements ParamsValidator<QuizTaskParams> {
    validate(params: QuizTaskParams) {
        sanityCheck(params.options.includes(params.correctAnswer), "Correct answer must be listed in options");
    }
}
